// 订单
export default [
  /*  订单列表 */
  // 待翻译
  {
    path: '/orderTranslate',
    name: 'orderTranslate',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderTranslate/index'),
    meta: {
      activeMenu: 'orderTranslate', // 可用选中菜单
    }
  },
  // 订单确认
  {
    path: '/orderNotarize',
    name: 'orderNotarize',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderNotarize/index'),
    meta: {
      activeMenu: 'orderNotarize', // 可用选中菜单
    }
  },
  // 订单报价
  {
    path: '/orderQuote',
    name: 'orderQuote',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderQuote/index'),
    meta: {
      activeMenu: 'orderQuote', // 可用选中菜单
    }
  },
  // 订单支付
  {
    path: '/orderPay',
    name: 'orderPay',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderPay/index'),
    meta: {
      activeMenu: 'orderPay', // 可用选中菜单
    }
  },
  // 订单待入金
  {
    path: '/orderWaitPaySubmit',
    name: 'orderWaitPaySubmit',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderPendingDeposit/index'),
    meta: {
      activeMenu: 'orderWaitPaySubmit', // 可用选中菜单
    }
  },
  //  订单入金待确认
  {
    path: '/orderPayWaitConfirm',
    name: 'orderPayWaitConfirm',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderDepositToBeConfirmed/index'),
    meta: {
      activeMenu: 'orderPayWaitConfirm', // 可用选中菜单
    }
  },
  // 可发货订单
  {
    path: '/deliverableOrder',
    name: 'deliverableOrder',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/deliverableOrder/index'),
    meta: {
      activeMenu: 'deliverableOrder', // 可用选中菜单
    }
  },

  // 进行中订单
  {
    path: '/underwayOrder',
    name: 'underwayOrder',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/underwayOrder/index'),
    meta: {
      activeMenu: 'underwayOrder', // 可用选中菜单
    }
  },
  // 待拍下商品
  {
    path: '/toBePhotographedGoods',
    name: 'toBePhotographedGoods',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/toBePhotographedGoods/index'),
    meta: {
      activeMenu: 'toBePhotographedGoods', // 可用选中菜单
    }
  },
  //客户已付款的订单
  {
    path: '/orderPaymentCompleted',
    name: 'orderPaymentCompleted',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/orderPaymentCompleted/index'),
    meta: {
      activeMenu: 'orderPaymentCompleted', // 可用选中菜单
    }
  },
  //跟单记录
  {
    path: '/documentaryRecords',
    name: 'documentaryRecords',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/documentaryRecords/index.vue'),
    meta: {
      activeMenu: 'documentaryRecords', // 可用选中菜单
    },


  },

  // 临时订单
  {
    path: '/temporaryOrder',
    name: 'temporaryOrder',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/temporaryOrder/index.vue'),
    meta: {
      activeMenu: 'temporaryOrder', // 可用选中菜单
    },
  },

  // 未到货订单
  {
    path: '/ordersNotArrived',
    name: 'ordersNotArrived',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/ordersNotArrived/index.vue'),
    meta: {
      activeMenu: 'ordersNotArrived', // 可用选中菜单
    }
  },



  /* 核查检品*/
  // 商品核查
  {
    path: '/commodityInspection',
    name: 'commodityInspection',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/commodityInspection/index'),
    meta: {
      activeMenu: 'commodityInspection', // 可用选中菜单
    }
  },
  // 检品列表
  {
    path: '/menu3_follow_inspect_inspect',
    name: 'menu3_follow_inspect_inspect',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/inspectionList/index'),
    meta: {
      activeMenu: 'menu3_follow_inspect_inspect', // 可用选中菜单
    }
  },
  // 待跟进物流
  {
    path: '/pendingFollowUpLogistics',
    name: 'pendingFollowUpLogistics',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/pendingFollowUpLogistics/index.vue'),
    meta: {
      activeMenu: 'pendingFollowUpLogistics', // 可用选中菜单
    }
  },
  // 机械操作订单
  {
    path: '/mechanicalOperationOrder',
    name: 'mechanicalOperationOrder',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/mechanicalOperationOrder/index.vue'),
    meta: {
      activeMenu: 'mechanicalOperationOrder', // 可用选中菜单
    }
  },
  // 布标操作单
  {
    path: '/fabricLabelOperationOrder',
    name: 'fabricLabelOperationOrder',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/fabricLabelOperationOrder/index.vue'),
    meta: {
      activeMenu: 'fabricLabelOperationOrder', // 可用选中菜单
    }
  },
  // FBA操作订单
  {
    path: '/FBAOperationOperationOrder',
    name: 'FBAOperationOperationOrder',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/FBAOperationOperationOrder/index.vue'),
    meta: {
      activeMenu: 'FBAOperationOperationOrder', // 可用选中菜单
    }
  },
  // 摄影操作订单
  {
    path: '/photographyOperationOrder',
    name: 'photographyOperationOrder',
    component: () => import( /* webpackChunkName: "inspection" */ '@/views/home/inspection/photographyOperationOrder/index.vue'),
    meta: {
      activeMenu: 'photographyOperationOrder', // 可用选中菜单
    }
  },
  /* 拍摄服务 */
  // 拍摄订单
  {
    path: '/photographyOrder',
    name: 'photographyOrder',
    component: () => import( /* webpackChunkName: "photographyServices" */ '@/views/home/photographyServices/photographyOrder/index.vue'),
    meta: {
      activeMenu: 'photographyOrder', // 可用选中菜单
    }
  },
  // 待拍摄任务
  {
    path: '/taskToBeFilmed',
    name: 'taskToBeFilmed',
    component: () => import( /* webpackChunkName: "photographyServices" */ '@/views/home/photographyServices/taskToBeFilmed/index.vue'),
    meta: {
      activeMenu: 'taskToBeFilmed', // 可用选中菜单
    }
  },
  // rakuAi
  {
    path: '/rakuai',
    name: 'rakuai',
    component: () => import( /* webpackChunkName: "photographyServices" */ '@/views/home/photographyServices/rakuAi/index.vue'),
    meta: {
      activeMenu: 'rakuai', // 可用选中菜单
    }
  },
  // 自动询货信息设置
  {
    path: '/autoInquiryProductMessageSettings',
    name: 'autoInquiryProductMessageSettings',
    component: () => import( /* webpackChunkName: "orderList" */ '@/views/home/order/autoInquiryProductMessageSettings/index.vue'),
    meta: {
      activeMenu: 'autoInquiryProductMessageSettings', // 可用选中菜单
    }
  },
]